import React from 'react';
import Link from 'next/link';

import styles from './bottom-bar.module.css';

export type BaseProps = React.PropsWithChildren & React.HTMLAttributes<HTMLElement> & {
  /** Button is a link? */
  url?: string;
}

export type LinkProps = {
  /** Button is a link? */
  url: string;
}

export type ButtonProps = React.PropsWithChildren & React.HTMLProps<HTMLButtonElement> & {
  /** Optional click handler */
  onClick?: () => void;
}

const LinkAsButton = ({url, ...props}: LinkProps) => <Link href={url} prefetch={false} className={styles.button} {...props}/>

/** Primary UI component for user interaction */
export const BarButton = ({url, ...props }: BaseProps) => {
  return url ? <LinkAsButton url={url} {...props}/> : (
      <button
        type="button"
        className={styles.button}
        {...props}/>
    );
};
